import { useState, useContext, useCallback } from 'react';
import { useDeepCompareEffect } from 'src/hooks/useDeepCompare';
import { usePrevious } from 'src/hooks/usePrevious';
import { useSelector } from 'react-redux';
import { selectComponent, selectLinkData } from 'src/redux/layout/topListLayoutSelectors';
import { updateLinkedData, updateComponent } from 'src/redux/layout/topListLayoutActions';
import LayoutContext from '../app/TopListsMosaic/layout/LayoutContext';

/*
Linking logic for Top Lists Mosaic.

Decides whether to use the regular layout Link state,
or the 'None' link state stored within the component
*/
export default function useToplistLinkedValues() {
  const { componentId, layoutId } = useContext(LayoutContext);
  const {
    link,
    noLinkData = {}
  } = useSelector(selectComponent(componentId, layoutId));
  const linkedData = useSelector(selectLinkData(link));
  const prevLinkColor = usePrevious(link);
  const [currLinkedData, setCurrLinkedData] = useState(link === 'none' ? noLinkData : linkedData);

  const memoizedUpdateLinkedData = useCallback((data) => {
    if (link === 'none') {
      return updateComponent(componentId, layoutId, {
        noLinkData: data
      });
    } else {
      return updateLinkedData(link, data);
    }
  }, [link, componentId, layoutId]);


  useDeepCompareEffect(() => {
    if (link === 'none') {
      setCurrLinkedData(noLinkData);
    } else if (link === prevLinkColor) {
      setCurrLinkedData(linkedData);
    }
  }, [link, linkedData, noLinkData]);

  return { link, linkedData: currLinkedData, memoizedUpdateLinkedData: memoizedUpdateLinkedData };
}
